import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import { useQueryClient } from 'react-query';
import { MenuItem, Select } from '@mui/material';
import { refreshTokenSucess } from 'store/auth';
import { updateLanguagePreference } from 'services/users-service';

const LANGUAGES = [
  { code: 'pt', label: 'Portugues' }, // Native names — NOT translated
  { code: 'en', label: 'English' },
  { code: 'es', label: 'Espanol' },
];

const LanguageSelector = () => {
  const { i18n } = useTranslation();
  const dispatch = useDispatch();
  const queryClient = useQueryClient();

  const handleChange = async (event) => {
    const newLang = event.target.value;

    // 1. Instant UI update (optimistic) — localStorage updated automatically by i18next-browser-languagedetector
    i18n.changeLanguage(newLang);

    // 2. Invalidate React Query cache — active queries refetch with new language in background
    // Do NOT use queryClient.clear() — that cancels in-flight queries
    queryClient.invalidateQueries();

    // 3. Persist to backend (async, non-blocking — fire-and-forget)
    try {
      const response = await updateLanguagePreference(newLang);
      if (response.data?.token) {
        dispatch(refreshTokenSucess(response.data));
      }
    } catch (error) {
      // Silent failure — localStorage keeps the preference
      // Next login will sync from backend fallback chain
      console.warn('Language preference save failed:', error.message);
    }
  };

  return (
    <Select
      value={i18n.language || 'pt'}
      onChange={handleChange}
      size="small"
      variant="standard"
      sx={{ minWidth: 100, color: 'inherit' }}
    >
      {LANGUAGES.map(({ code, label }) => (
        <MenuItem key={code} value={code}>
          {label}
        </MenuItem>
      ))}
    </Select>
  );
};

export default LanguageSelector;
